<template>
  <div class="wg-row" style="height:100%;position:relative;">
    <div class="wg-row" style="z-index:1000;position:absolute;top:10px;flex-wrap:nowrap;align-items:center;justify-content:center;">
      <select
        class="com-anm22-app-select com-anm22-app-select"
        id="yb-license-sel"
        style="padding:2px;"
        :value="ybLicenseSelected.ybLicense"
        @change="selected = $event.target.value;loadMap();"
      >
        <option
          v-for="(ybl,index) in ybLicenses"
          :key="'ybl'+index"
          :value="ybl.ybLicense"
        >{{ $store.getters['works/get'](ybl.beach).name }}</option>
      </select>
    </div>
    <!-- <div class="vertical-height-div" style="height:10px;"></div> -->
    <div v-if="map" class="com-anm22-food-scrolling-panel" style="height:100%">
      <div id="map" style="width:100%;position:relative;overflow-y:hidden;overflow-x:auto;">
        <div id="map_sea" :style="{width: map.width + 'px', minWidth: '100%' }"></div>
        <div
          id="map_beach"
          :style="{ position: 'relative', width: map.width + 'px', minWidth: '100%', height: map.height + 'px' }"
        >
          <div style="padding:0 45px;">
            <div
              id="beach_map_elements"
              :style="{ width: map.internalWidth + 'px', height: map.height + 'px', position: 'relative', margin: '0 auto', display: 'block'}"
            >
              <img v-if="map.background"
                  class="map-custom-bg" 
                  :src="map.background.url"
                  :style="{
                    width: map.background.width + 'px',
                    height: map.background.height + 'px',
                    left: map.background.left + 'px',
                    top: map.background.top + 'px',
                    position: 'absolute',
                  }" 
              >
              <template v-for="(element, index) in map.elements">
                <div
                  v-if="element.type === 'cabin'"
                  :key="'map-el-'+index"
                  :class="[element.class]"
                  :style="{ left: element.posX + 'px', top: element.posY + 'px' }"
                ></div>
                <div
                  v-if="element.type === 'footboard'"
                  :key="'map-el-'+index"
                  :class="[element.class]"
                  :style="{ left: element.posX + 'px', top: element.posY + 'px' }"
                ></div>
                <div
                  v-if="element.type === 'umbrella' || element.type === 'gazebo'"
                  :key="'map-el-'+index"
                  :id="element.id"
                  :class="[element.class]"
                  :style="{
                        left: element.posX + 'px',
                        top: element.posY + 'px'
                      }"
                  @click="element.registration ? elementClick(element.name, element.registration) : ''"
                  v-html="element.content"
                ></div>
              </template>
            </div>
          </div>
        </div>
        <div id="map_end_sand" :style="{width: map.width + 'px', minWidth: '100%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    selectRef: Number,
    mode: String
  },
  data() {
    return {
      selected: this.selectRef ? this.selectRef : null,
      map: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      selectedLicense: state => state.licenseSelected
    }),
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.selectedLicense
      );
    },
    ybLicenses() {
      return this.$store.getters['ybLicenses/getByLicense'](this.license.id);
    },
    ybLicenseSelected() {
      if(this.selected) {
        return this.ybLicenses.find(l => l.beach === this.selected);
      } else {
        return this.ybLicenses[0];
      }
    }
  },
  methods: {
    elementClick(umbrella, registration) {
      if(this.mode === 'payment') {
        this.setYbPayment(umbrella, registration);
      } else {
        this.setYbDelivery(umbrella);
      }
      this.$anm22.eventBus.$emit('wg-modal-close');
    },
    setYbPayment(umbrella, registration) {
      this.$emit('yb-payment', {
        beachId: this.ybLicenseSelected.beach,
        beachLicense: this.ybLicenseSelected.ybLicense,
        umbrella: umbrella,
        registration: registration
      });
    },
    setYbDelivery(umbrella) {
      this.$emit('yb-delivery', {
        beachId: this.ybLicenseSelected.beach,
        umbrella: umbrella
      });
    },
    loadMap() {
      this.map = null;
      this.$http.post('fast-cash/load-yb-map', {
        beach: this.ybLicenseSelected.ybLicense
      })
      .then(response => {
        this.map = response.data.map;
      });
    }
  },
  created() {
    this.loadMap();
  }
};
</script>

<style lang="scss" scoped>
</style>
